import { Box, BoxProps } from '@chakra-ui/react'
import { Trans } from 'next-i18next'
import { ChangeEventHandler } from 'react'
import { APP_ROUTES } from '_app/routes'
import { Checkbox } from './Form'
import { LinkText } from '.'

interface Props extends BoxProps {
  name: string;
  onCheckboxChange?: ChangeEventHandler<HTMLInputElement>;
}

export const AcceptRegulations = ({
  name,
  onCheckboxChange,
  ...props
}: Props) => {
  // in the original version, this component was returning null if customer was logged in
  // after talking to Darek it was decided to always display it
  // const { customer } = useCustomer();

  return (
    <Box id={name} {...props}>
      <Checkbox
        isRequired
        name={name}
        label={
          <Trans
            i18nKey="ACCEPT_CONDITIONS"
            ns="common"
            components={{
              link1: <LinkText href={APP_ROUTES.TERMS_AND_CONDITIONS} />,
              link2: <LinkText href={APP_ROUTES.PRIVACY_POLICY} />,
            }}
          />
        }
        onChange={onCheckboxChange}
      />
    </Box>
  )
}
